module.exports = __webpack_public_path__ + "static/media/ellipse.ca0cde1e.webp";